import { ErrorCircle } from '@ori-ui/icons';
import { styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var InputErrorIconRoot = styled('div')(function () {
  return {
    position: 'relative',
    '&:hover': {
      '.inputErrorIconTooltip': {
        display: 'flex'
      }
    }
  };
});
var InputErrorIconWrapper = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    color: theme.palette.error.main,
    fontSize: theme.typography.pxToRem(28),
    height: theme.spacing(4),
    lineHeight: theme.typography.pxToRem(20),
    width: theme.spacing(4)
  };
});
var InputErrorIconTooltip = styled('div')(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: 'none',
    position: 'absolute',
    right: 'calc(0% - 5px)',
    top: 'calc(100% + 10px)',
    zIndex: 10,
    '&::after, &::before': {
      border: '8px solid transparent',
      borderBottom: "8px solid ".concat(theme.palette.common.white),
      content: '""',
      display: 'block',
      position: 'absolute',
      right: 'calc(0% + 3px)',
      top: '-15px',
      zIndex: '10'
    },
    '&::after': {
      borderBottom: "8px solid ".concat(theme.palette.grey[300]),
      top: '-16px',
      zIndex: 9
    }
  };
});
var InputErrorIconTooltipContent = styled('div')(function (_ref3) {
  var theme = _ref3.theme;
  return {
    background: theme.palette.common.white,
    border: "1px solid ".concat(theme.palette.grey[300]),
    borderRadius: 4,
    fontSize: theme.typography.pxToRem(15),
    padding: theme.spacing(3, 4)
  };
});
export var InputErrorIcon = function InputErrorIcon(_ref4) {
  var error = _ref4.error;

  var _useTestId = useTestId(),
      getTestId = _useTestId.getTestId;

  return /*#__PURE__*/_jsxs(InputErrorIconRoot, {
    "data-testid": getTestId('input-error-icon'),
    children: [/*#__PURE__*/_jsx(InputErrorIconWrapper, {
      children: /*#__PURE__*/_jsx(ErrorCircle, {
        fontSize: "inherit"
      })
    }), /*#__PURE__*/_jsx(InputErrorIconTooltip, {
      className: "inputErrorIconTooltip",
      children: /*#__PURE__*/_jsx(InputErrorIconTooltipContent, {
        children: error
      })
    })]
  });
};